__turbopack_context__.v({
  "header": "LbwfuG_header",
  "headerLeft": "LbwfuG_headerLeft",
  "headerRight": "LbwfuG_headerRight",
  "humbergerMenu": "LbwfuG_humbergerMenu",
  "logo": "LbwfuG_logo",
  "logout": "LbwfuG_logout",
  "menu": "LbwfuG_menu",
  "navigation": "LbwfuG_navigation",
  "serviceName": "LbwfuG_serviceName",
});
